import SatisfactionScore from './SatisfactionScore';
export default SatisfactionScore;
